import { scrollToId } from "@/lib/scroll";
import { Reveal } from "./Reveal";

export const FoundingBand = ({ onApply }) => (
  <section data-testid="founding-band" className="border-y border-graphite bg-onyx/40">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10 sm:py-12 flex flex-col lg:flex-row lg:items-center gap-8 justify-between">
      <Reveal className="max-w-xl">
        <p className="font-accent text-[10px] tracking-[0.35em] uppercase text-volt">Founding Member Access</p>
        <p className="text-silver/80 text-sm leading-relaxed mt-3">
          The first 10 accepted vehicles into Private Care receive a founding rate of $149/month while membership remains active.
        </p>
      </Reveal>
      <Reveal delay={0.1} className="flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-10 shrink-0">
        <div data-testid="founding-band-spots">
          <p className="font-accent text-[10px] tracking-[0.25em] uppercase text-ivory">2 reserved · 8 remaining</p>
          <p className="font-accent text-[10px] tracking-[0.25em] uppercase text-silver/50 mt-2">Standard rate: $169/month</p>
        </div>
        <button
          data-testid="founding-band-cta"
          onClick={() => { onApply?.("PRIVATE CARE"); scrollToId("request"); }}
          className="self-start font-accent text-xs tracking-[0.25em] uppercase border border-volt/60 text-volt px-8 py-4 hover:bg-volt hover:text-white transition-colors duration-300"
        >
          Apply for Founding Access
        </button>
      </Reveal>
    </div>
  </section>
);
